  <section class="main-section">
    <header class="d-flex justify-content-between align-items-center main-heading">
      <div class="d-flex align-items-center">
        <a class="btn btn-link me-3 p-0 d-block d-xl-none" data-bs-toggle="offcanvas" href="#offcanvasExample" role="button" aria-controls="offcanvasExample">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round"/>
          </svg></a>
        <h3 class="heading-span"><span>{{pageTitle ? pageTitle : activeTab + " Centre"}}</span></h3>
      </div>
      <div class="">
        <div class="d-flex" *ngIf="!pageTitle && !hideGlobalCreate && (activeTab == tabs.Package && userRole?.includes(roles.SuperAdmin))">
          <button type="button" class="btn theme-btn px-sm-4 px-2" (click)="showCreateForm(); setPageTitleTriggered({tab: activeTab, mode: mode.Create})">
            <span class="d-block d-sm-none"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12 5V19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg></span>
            <span class="d-none d-sm-block">Create {{activeTab}}</span>
          </button>
        </div>
      </div>
    </header>

    <app-package [isCurrentTab] = "activeTab" (close)="closeCreateForm()" (setPageTitle)="setPageTitleTriggered($event)" (hideGlobalCreate)="hideCreate($event)" [showForm] = showForm></app-package>
  </section>
